import { fontFamily } from '@/types/tower/Tower';
import { DEFAULT_STROKE_WIDTH, DEFAULT_TEXT_STYLE } from '@/utilities/tower/v2/Canvas';
import { fabric } from 'fabric';
import LabeledObjectBase from './LabeledObjectBase';

export const TYPE = 'legend-rect';

const LegendRect = fabric.util.createClass(LabeledObjectBase, {
  type: TYPE,
  label: undefined as fabric.Textbox | undefined,

  initialize: function(options: fabric.RectOptions | any) {
    options = options || {};

    const objects: fabric.Object[] = [];

    this.textColor = options.textColor ?? '#FFFFFF';

    if (options.objects) {
      objects[0] = new fabric.Rect(options.objects[0]);
      objects[1] = new fabric.Textbox('', options.objects[1]);
    } else {
      objects[0] = new fabric.Rect({
        originX: 'center',
        originY: 'center',
        fill: '#FF0000',
        opacity: 0.5,
        stroke: '#61BABA',
        strokeWidth: DEFAULT_STROKE_WIDTH,
        strokeDashArray: [0],
        strokeUniform: true,
        paintFirst: 'stroke',
      });

      objects[1] = new fabric.Textbox('', {
        fontSize: 18,
        originX: 'center',
        originY: 'center',
        textAlign: 'center',
        fill: 'white',
        strokeDashArray: [0],
        strokeUniform: true,
        lockScalingX: true,
        lockScalingY: true,
      });

      this.textStyle = DEFAULT_TEXT_STYLE;
      objects[1].fontFamily = fontFamily(this.textStyle);
    }

    this.callSuper('initialize', objects, {...options, strokeUniform: true});
    this.resizeLabel();

    this.on('mousedblclick', () => {
      // this.editLabel();
    });
  },

  toObject: function() {
    return fabric.util.object.extend(this.callSuper('toObject'), {
      id: this.id,
      policy: this.policy,
      lockScalingFlip: this.lockScalingFlip,
      textColor: this.textColor,
    });
  },

  setLabel: function(text: string) {
    this._objects[1].set('text', text);
  },
});

LegendRect.fromObject = function(object: fabric.Object, callback: (obj: fabric.Object) => void) {
  const labelRect = new LegendRect(object);
  if (callback) callback(labelRect);
  return labelRect;
};

export default LegendRect;
